import { FC, PropsWithChildren, ReactNode } from 'react';

interface PageScaffoldProps extends PropsWithChildren {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  showDivider?: boolean;
  actionsPosition?: 'left' | 'right';
}

const PageScaffold: FC<PageScaffoldProps> = ({ title, subtitle, actions, children, showDivider = true, actionsPosition = 'right' }) => {
  return (
    <div className="rounded-[28px] border border-slate-200/70 bg-white/95 p-8 shadow-[0_20px_45px_-32px_rgba(37,40,85,0.55)] min-h-[calc(100vh-220px)]">
      <header className={`flex flex-col gap-4 ${showDivider ? 'border-b border-slate-200 pb-6' : ''} md:flex-row md:items-center md:justify-between`}>
        <div className="flex items-start gap-3">
          {actions && actionsPosition === 'left' ? (
            <div className="flex items-center gap-2">{actions}</div>
          ) : null}
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-primary/60">{title}</div>
            {subtitle ? (
              <p className="mt-1 max-w-2xl text-sm text-slate-500">{subtitle}</p>
            ) : null}
          </div>
        </div>
        {actions && actionsPosition === 'right' ? <div className="flex items-center gap-2">{actions}</div> : null}
      </header>

      <div className="mt-6 min-h-[320px] rounded-2xl border border-dashed border-primary/15 bg-white/95 p-6 text-sm text-slate-500">
        {children ?? 'Content coming soon.'}
      </div>
    </div>
  );
};

export default PageScaffold;
